import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { queryKeys } from '@/shared/query';
import { labMaterialAPI, labShadeAPI, labWorkTypeAPI, type LabCatalogItem } from '../api/labCatalog.api';

export const useLabWorkTypes = (includeInactive = false) =>
  useQuery({
    queryKey: queryKeys.labo.workTypes({ includeInactive }),
    queryFn: async (): Promise<LabCatalogItem[]> => {
      const res = await labWorkTypeAPI.getAll(includeInactive);
      return res.data ?? [];
    },
    placeholderData: keepPreviousData,
  });

export const useLabMaterials = (includeInactive = false) =>
  useQuery({
    queryKey: queryKeys.labo.materials({ includeInactive }),
    queryFn: async (): Promise<LabCatalogItem[]> => {
      const res = await labMaterialAPI.getAll(includeInactive);
      return res.data ?? [];
    },
    placeholderData: keepPreviousData,
  });

export const useLabShades = (includeInactive = false) =>
  useQuery({
    queryKey: queryKeys.labo.shades({ includeInactive }),
    queryFn: async (): Promise<LabCatalogItem[]> => {
      const res = await labShadeAPI.getAll(includeInactive);
      return res.data ?? [];
    },
    placeholderData: keepPreviousData,
  });

/** Map code → name (includes inactive when loaded with includeInactive). */
export const buildLabCatalogLabelMap = (items: LabCatalogItem[]): Record<string, string> => {
  const map: Record<string, string> = {};
  for (const item of items) {
    map[item.code] = item.name;
  }
  return map;
};
